var $23b4dd964f7cc840$exports = {};
$23b4dd964f7cc840$exports = {
    "Empty": `Leer`
};


export {$23b4dd964f7cc840$exports as default};
//# sourceMappingURL=de-DE.mjs.map
